/**
 * Performance tab of the Social Studio — organic numbers and comments for
 * the posts published through BuzzBit X, on every channel.
 *
 * Its own slice for the reason enScheduling.ts records (en.ts sits on the
 * 500-line ceiling). Spread into enComposer, which en.ts already spreads, so
 * `t()` and MessageKey see these keys without touching en.ts.
 */
export const enPerformance = {
  'performance.tab': 'Performance',
  'performance.title': 'How your posts are doing',
  'performance.subtitle':
    'Reach, engagement, and comments for every post you published.',
  'performance.window': 'Time window',
  'performance.days': 'Last {days} days',
  'performance.loading': 'Loading your posts…',
  'performance.loadFailed': 'We couldn’t load your post numbers. Check your connection and try again.',
  'performance.retry': 'Try again',
  'performance.empty': 'No published posts in this window.',
  'performance.emptyHint': 'Publish from the Composer and the reach, likes, and comments will land here.',
  'performance.emptyCta': 'Open Composer',
  'performance.failedHint': 'Tap Try again when your connection is back.',
  'performance.allChannels': 'All channels',
  'performance.multi': 'Cross-posted',
  'performance.multiHint': 'Posts sent to several channels. Each channel’s numbers are listed separately; a failure on one does not hide the others.',
  'performance.capped': 'Totals cover your latest {count} posts in this window.',
  'performance.posts': '{count} posts',
  'performance.metric.reach': 'Reach / views',
  'performance.metric.likes': 'Likes',
  'performance.metric.comments': 'Comments',
  'performance.metric.shares': 'Shares',
  'performance.metric.received': 'In inbox',
  'performance.metric.receivedHint': 'Comments that reached your BuzzBit X inbox',
  'performance.notAvailable': 'Not available',
  'performance.reachHint': 'Reach is Instagram reach, X impressions, and YouTube or TikTok views.',
  'performance.refreshHint': 'Numbers refresh every hour for posts from the last 30 days.',
  'performance.col.post': 'Post',
  'performance.col.channels': 'Channels',
  'performance.col.published': 'Published',
  'performance.col.link': 'Link',
  'performance.viewOn': 'View on {platform}',
  'performance.noLink': 'No public link',
  'performance.openComments': 'See comments',
  'performance.noCaption': 'No caption',
  'performance.metricsError': 'Last update failed for {platforms} — reconnect the account to refresh these numbers.',
  'performance.channelError': '{platform}: {message}',
  'performance.prev': 'Previous',
  'performance.next': 'Next',
  'performance.pageOf': 'Page {page} of {pages}',
  'performance.note.FACEBOOK': 'Facebook doesn’t report reach for a single post through this connection.',
  'performance.note.YOUTUBE': 'YouTube doesn’t report shares.',
  'performance.note.LINKEDIN': 'LinkedIn doesn’t report views or shares for a member post.',
  'performance.note.TIKTOK': 'TikTok views need the video.list permission, which isn’t granted yet — so TikTok numbers aren’t read.',
  'performance.note.PINTEREST': 'Pinterest numbers aren’t read yet.',
  'performance.note.generic': '{platform}: some numbers aren’t available.',
  'performance.platform.INSTAGRAM': 'Instagram',
  'performance.platform.FACEBOOK': 'Facebook',
  'performance.platform.TIKTOK': 'TikTok',
  'performance.platform.LINKEDIN': 'LinkedIn',
  'performance.platform.YOUTUBE': 'YouTube',
  'performance.platform.X': 'X',
  'performance.platform.PINTEREST': 'Pinterest',
  'performance.comments.title': 'Comments',
  'performance.comments.close': 'Close comments',
  'performance.comments.loading': 'Loading comments…',
  'performance.comments.empty': 'No comments on this post have reached your inbox yet.',
  'performance.comments.failed': 'We couldn’t load the comments. Try again in a moment.',
  'performance.comments.forbidden': 'You need permission to view customers to see who commented.',
  'performance.comments.unknownAuthor': 'Unknown',
  'performance.comments.reply': 'Reply',
  'performance.comments.replyPlaceholder': 'Write a public reply…',
  'performance.comments.replySending': 'Sending…',
  'performance.comments.replySent': 'Reply posted on the platform.',
  'performance.comments.replyFailed': 'Could not post the reply. Check connection and try again.',
  'performance.comments.openInbox': 'Open in Inbox',
} as const;
